import { gql } from '@apollo/client'
import { NOTIFICATION_FIELDS } from './fragments/notification'

export const NOTIFICATION_INBOX = gql`
  ${NOTIFICATION_FIELDS}
  query notificationInbox($after: String, $first: Int, $stateFilter: NotificationInboxStateFilter) {
    notificationInbox(after: $after, first: $first, stateFilter: $stateFilter) {
      nextCursor
      unreadCount
      notifications {
        ...NotificationFields
      }
    }
  }
`
